import { http } from '@/lib/ats-https';

// Coordinator credit-cap 402 (POST /coordinator_sessions and the voice-agent
// flows). Mirrors the CBV CreditCapError shape but carries the coordinator
// manage-permission field.
export interface CoordinatorCapError {
  errors: string[];
  error_code: string;
  cap_status: {
    exceeded: boolean;
    count: number;
    cap: number;
    remaining: number;
  };
  // manage_credits permission for the coordinator.
  user_has_manage_org_coordinator: boolean;
  reminder_sent_recently: boolean;
}

const COORDINATOR_CAP_ERROR_CODES = new Set([
  'err_ai_coordinator_insufficient_credits',
  'err_ai_coordinator_feature_cap_exceeded',
  'err_ai_coordinator_monthly_cap_exceeded',
]);

// True when an error is a coordinator credit-cap 402. Handles the three shapes
// it can arrive in: a raw 200-with-error body (`error_code` at the root), the
// ats-https rejection (which rejects with `error.response`, so the body is at
// `.data`), and a plain axios error (`.response.data`).
export const isCoordinatorCapError = (error: unknown): boolean => {
  const code =
    (error as any)?.error_code ??
    (error as any)?.data?.error_code ??
    (error as any)?.response?.data?.error_code ??
    (error as any)?.errors?.[0];
  return typeof code === 'string' && COORDINATOR_CAP_ERROR_CODES.has(code);
};

// Normalises any of those shapes into the cap payload the modal reads.
export const getCoordinatorCapData = (error: unknown): CoordinatorCapError => {
  const e = error as any;
  if (e?.error_code) return e as CoordinatorCapError;
  if (e?.data?.error_code) return e.data as CoordinatorCapError;
  return e?.response?.data as CoordinatorCapError;
};

// POST /coordinator_sessions/request_credit_cap_notification (no body) — pings
// admins to top up. Called from the "Notify admin" CTA.
export const notifyCoordinatorCredits = async (): Promise<void> => {
  await http.post('/coordinator_sessions/request_credit_cap_notification', {});
};
